import _ from "lodash";
import axios from "axios";

import { sisi_api_url, website_api_key } from "../api";

export const getRoutesByOriginPort = async (originPort) => {
  try {
    const response = await axios.get(
      `${sisi_api_url}/vesselengine/routes/by-origin-port/${originPort}`
    );
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
  }
  return null;
};

// ======================= SEARCH FERRIES ========================
export const searchRequestFerries = async (payload) => {
  try {
    const response = await axios.post(`${sisi_api_url}/vesselengine/search/`, {
      ...payload,
      website_api_key,
    });
    return _.get(response, "data", {});
  } catch (error) {
    console.error(error);
  }
  return null;
};

export const pollFerriesSearch = async ({ session_id, onError }) => {
  try {
    const response = await axios.get(
      `${sisi_api_url}/vesselengine/search/${session_id}/`
    );
    return _.get(response, "data", {});
  } catch (error) {
    return onError(error);
  }
};

export const retrieveFerryDetails = async ({ payload, onError }) => {
  try {
    const response = await axios.post(
      `${sisi_api_url}/vesselengine/refine-search/`,
      payload
    );
    return _.get(response, "data", {});
  } catch (error) {
    return onError(error);
  }
};

export const getPrices = async ({ payload, onError }) => {
  try {
    const response = await axios.post(
      `${sisi_api_url}/vesselengine/check-price/`,
      payload
    );
    return _.get(response, "data", {});
  } catch (error) {
    return onError(error);
  }
};

export const prebookUpdateFerries = async ({ payload, onError }) => {
  try {
    const response = await axios.post(
      `${sisi_api_url}/vesselengine/pre-book/`,
      payload
    );
    return _.get(response, "data", {});
  } catch (error) {
    return onError(error);
  }
};

export async function bookFerry({ payload, onError }) {
  try {
    const response = await axios.post(
      `${sisi_api_url}/vesselengine/book/`,
      payload
    );
    return _.get(response, "data", {});
  } catch (error) {
    return onError(error);
  }
}
